import { Smartphone, Globe, AtSign } from 'lucide-react'
import type { AnyObj } from '../types'

export const FRAUD_CHECKLIST_ICONS: Record<string, typeof Smartphone> = {
  device: Smartphone,
  'ip-risk': Globe,
  'contact-risk': AtSign,
}

export const FRAUD_CHECKLIST_DESCRIPTIONS: Record<string, string> = {
  device: 'Flags suspicious, jailbroken, or previously-seen-bad devices.',
  'ip-risk': 'Flags risky locations, VPNs, and known-bad networks.',
  'contact-risk': 'Flags disposable email addresses and high-risk phone numbers.',
}

const RISK_ORDER = ['LOW', 'MEDIUM', 'HIGH', 'UNACCEPTABLE']

export function overallFraudRiskLevel(checks: AnyObj[]): string | null {
  let worst: string | null = null
  for (const check of checks) {
    const level: string | undefined = check.riskLevel ?? check.supplementaryData?.['Risk.Level'] ?? check.providerResult?.supplementaryData?.['Risk.Level']
    if (!level) continue
    if (worst === null || RISK_ORDER.indexOf(level) > RISK_ORDER.indexOf(worst)) worst = level
  }
  return worst
}
